import script from "./LoaderCircleWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderCircleWrapper.vue?vue&type=script&setup=true&lang=js"

import "./LoaderCircleWrapper.vue?vue&type=style&index=0&id=b67e6546&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b67e6546"]])

export default __exports__